import { dataCustomerSettingsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCustomerSettingsSolid = /*#__PURE__*/createIcon(dataCustomerSettingsSolid)
export default IconCustomerSettingsSolid
